import { PointrThemedChoiceGroup } from 'components/pointr-themed-choice-group'
import { PointrThemedFormItem } from 'components/pointr-themed-form-item'
import React from 'react'
import { QuestionType } from 'types/IInitiativeSubmissionQuestions'
import { IInitiativeSubmissionFormItem } from './Interfaces'

const InitiativeSubmissionFormItem: React.FC<IInitiativeSubmissionFormItem> = ({
  classes,
  item,
  value,
  helperText,
  validationError,
  onChange,
  selected
}) => {
  switch (item.questionType) {
    case QuestionType.FREE_TEXT:
      return (
        <PointrThemedFormItem
          label={item.text}
          value={(value as string) || ''}
          maxLength={item.answerRules.maxLength}
          classes={classes}
          multiline
          rows={3}
          onChange={onChange}
          error={!!validationError}
          helperText={helperText}
        />
      )
    case QuestionType.MEDIA_LINK:
      return (
        <PointrThemedFormItem
          label={item.text}
          value={(value as string) || ''}
          classes={classes}
          onChange={onChange}
          error={!!validationError}
          helperText={helperText}
        />
      )
    case QuestionType.CHECKBOX:
      return (
        <PointrThemedChoiceGroup
          classes={classes}
          error={!!validationError}
          helperText={helperText}
          label={item.text}
          onChange={onChange}
          options={item.options}
          selected={selected}
          variant="checkbox"
        />
      )
    case QuestionType.MULTIPLE_CHOICE:
      return (
        <PointrThemedChoiceGroup
          classes={classes}
          error={!!validationError}
          helperText={helperText}
          label={item.text}
          onChange={onChange}
          options={item.options}
          selected={selected}
          variant="radio"
        />
      )
    default:
      return <React.Fragment />
  }
}

export default InitiativeSubmissionFormItem
